import { skipToken, useQuery } from '@tanstack/react-query';
import { fetchOperatorIdByUserId, fetchUserProfile } from './crud';

export const useFetchOperatorIdByUserId = (userId: string | undefined) => {
  return useQuery({
    queryKey: ['users-ref', userId],
    queryFn: userId ? () => fetchOperatorIdByUserId(userId) : skipToken,
  });
};

export const useFetchUserProfile = (userId: string | undefined) => {
  return useQuery({
    queryKey: ['users-profile', userId],
    queryFn: userId ? () => fetchUserProfile(userId) : skipToken,
  });
};
